var React = require('react');

function Restaurang (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M132.5 40v114a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3.1l2.1-60.9a3 3 0 0 0-3-3.1h-1.3c-1.3 0-2.5-.9-2.8-2.1-3.2-13.4-.8-33.5 2-48.4a3 3 0 0 1 2.9-2.4h8.1a3 3 0 0 1 3 3Z","stroke":"#000","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M77 157h-5.4a3 3 0 0 1-3-3L70 77.2a3 3 0 0 0-2.4-3L60.4 73a3 3 0 0 1-2.4-3V38a3 3 0 0 1 3-3h.6a3 3 0 0 1 3 3v23.4a3 3 0 0 0 3 3h.6a3 3 0 0 0 3-3V38a3 3 0 0 1 3-3h.6a3 3 0 0 1 3 3v23.4a3 3 0 0 0 3 3h.6a3 3 0 0 0 3-3V38a3 3 0 0 1 3-3h.6a3 3 0 0 1 3 3v32a3 3 0 0 1-2.4 2.9l-7.7 1.5a3 3 0 0 0-2.5 3l1.5 76.5a3 3 0 0 1-3 3.1Z","stroke":"#000","strokeWidth":"4","key":1})]);
}

Restaurang.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Restaurang;

Restaurang.default = Restaurang;
